import React, {useEffect, useState} from 'react';
import withHeader from '../../hoc/withHeader';
import {useHistory} from "react-router";
import {deleteBankById, fetchBanks} from "../../../services/bank.service";
import {useSelector} from "react-redux";

const BankPage = () => {
  const userData = useSelector(state => state.user.user);
  const [bankData, setBankData] = useState([]);
  const [bankDataTmp, setBankDataTmp] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const history = useHistory();

  useEffect(() => {
    if (userData.role.label === 'ca') {
      history.push('/panel/dashboard-ca');
    }
    banksData();
  }, [history, userData]);

  const banksData = () => {
    setLoading(true);
    fetchBanks().then(res => {
      setBankDataTmp(res.data.data);
      setBankData(res.data.data);
    }, err => {
      alert('Error load data');
      console.log('err', err.response);
    }).finally( () => {
      setLoading(false);
    });
  }

  const handleChange = async (event) => {
    await setSearch(event.target.value)
    let searchRes = bankDataTmp;

    if (!event.target.value) {
      setBankData(bankDataTmp);
      return;
    }

    const searchRes2 = searchRes.filter((val) => {
      return val.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 ||
          val.kode.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
    });
    setBankData(searchRes2);
  }

  const deleteHandler = (id) => {
    // console.log(id);
    // eslint-disable-next-line no-restricted-globals
    const r = confirm("are you sure to delete this data?");
    if (!r) {
      return;
    }
    deleteBankById(id, {}).then(res => {
      console.log(res);
      alert('delete data success');
      banksData();
    }, err => {
      alert('Error load data');
      console.log('err', err.response);
    }).finally( () => {
      setLoading(false);
    });
  }

  const createNewBankHandler = () => {
    console.log('new');
    history.push('/panel/banks/new');
  }

  const updateBankHandler = (id) => {
    console.log('new');
    history.push('/panel/banks/edit/' + id);
  }

  const loopBank = () => {
    return bankData.map((val, i) => {
      let url = {};
      if (val.url) {
        url = JSON.parse(val.url);
      } else {
        url = {
          url: '',
          method: '',
          param: '',
          url_inq: '',
          url_pay: '',
          url_adv: '',
          url_rev: '',
        };
      }

      return (
          <tr key={i}>
            <td>{ val._id }</td>
            <td>{ val.kode }</td>
            <td>{ val.name }</td>
            <td>{ val.user }</td>
            <td>{ val.password }</td>
            <td>{ val.secret_code }</td>
            <td>{ url.url }</td>
            <td>{ url.method }</td>
            <td>{ JSON.stringify(url.param) }</td>
            <td>{ url.url_inq }</td>
            <td>{ url.url_pay }</td>
            <td>{ url.url_rev }</td>
            <td>{ url.url_adv }</td>
            <td>
              <span className="badge bg-danger mr-1" onClick={() => { deleteHandler(val._id)}}>
                <i className="fas fa-trash-alt p-1" aria-hidden="true" />
              </span>

              <span className="badge bg-success mr-1" onClick={() => {updateBankHandler(val._id)}}>
                <i className="fas fa-pencil-alt p-1" aria-hidden="true" />
              </span>
            </td>
          </tr>
      );
    })
  }

  return (
      <div className="row">
        <div className="col-8">
          <input
            type="text"
            name="table_search"
            className="form-control float-right p-1"
            value={search}
            onChange={handleChange}
            placeholder="Search" />
        </div>
        <div className="col-4">
          <button type="button" className="btn btn-block btn-primary" onClick={() => {createNewBankHandler()}}>
            <i className='fas fa-plus' aria-hidden='true' />
          </button>
        </div>
        <div className="col-12">
          <hr className='hr-user' />
        </div>
        <div className="col-12">
          <div className="card-body table-responsive p-0">
            <table className="table table-hover text-nowrap">
              <thead>
              <tr>
                <th>ID</th>
                <th>Kode</th>
                <th>Name</th>
                <th>User</th>
                <th>Password</th>
                <th>Secret Code</th>
                <th>Base Url</th>
                <th>method</th>
                <th>param</th>
                <th>url_inq</th>
                <th>url_pay</th>
                <th>url_rev</th>
                <th>url_adv</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              { loading && <tr><td colSpan='6'>Load Data</td></tr> }
              { (!loading && bankData.length > 0) && loopBank() }
              </tbody>
            </table>
          </div>
        </div>
      </div>
  );
}

let pageSet = {
  title: "Bank",
  location: '/panel/banks'
}

export default withHeader(pageSet)(BankPage)
